
import moment from "moment";

export default function(date, locale) {
  if (locale === "undefined-undefined") {
    return "";
  }
  const n = new Date(date);
  return moment(n).utc().format('L')
}
